import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import WsIcon from "../assets/WsIcon.vue.es.js";
import WsSpinner from "../loaders/WsSpinner.vue.es.js";
import _sfc_main$1 from "../atoms/WsTooltip.vue.es.js";
/* empty css                         */
import { ButtonType, ButtonElement, ButtonSize } from "./WsButton.enum.es.js";
import { useTheming } from "../../core/plugins/theming/theming.es.js";
import { useMessages, useActions, Theme } from "@odin/services";
import axios from "axios";
import { defineComponent, useAttrs, computed, resolveComponent, resolveDirective, createElementBlock, createBlock, withCtx, createCommentVNode, withDirectives, mergeProps, resolveDynamicComponent, Fragment, openBlock, createTextVNode, createElementVNode as createBaseVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { ref, unref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
import { toDisplayString, normalizeClass } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "WsButton",
  props: {
    // Keep these first, so they can be used in default values.
    href: {
      type: String,
      required: false,
      default: void 0
    },
    type: {
      type: String,
      required: false,
      default: ButtonType.GHOST
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: "top"
    },
    element: {
      type: String,
      required: false,
      default: (props) => {
        if (props.submit) {
          return ButtonElement.BUTTON;
        }
        if (props.href && !props.ajax || props.targetBlank) {
          return ButtonElement.A;
        }
        return ButtonElement.BUTTON;
      }
    },
    size: {
      type: String,
      required: false,
      default: (props) => {
        if ([
          ButtonType.TERTIARY,
          ButtonType.TERTIARY_NEUTRAL,
          ButtonType.TERTIARY_AGENT,
          ButtonType.TERTIARY_DANGER
        ].includes(props.type)) {
          return ButtonSize.SMALL;
        }
        return ButtonSize.LARGE;
      }
    },
    icon: {
      type: String,
      required: false,
      default: void 0
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderColor: {
      type: String,
      required: false,
      default: void 0
    },
    // Ajax props
    ajax: {
      type: Boolean,
      required: false,
      default: false
    },
    url: {
      type: String,
      required: false,
      default: void 0
    },
    ajaxMethod: {
      type: String,
      required: false,
      default: "POST"
    },
    ajaxErrorMessagePath: {
      type: String,
      required: false,
      default: "general"
    },
    ajaxParams: {
      type: [Object, Array],
      required: false,
      default: () => {
      }
    },
    onSuccess: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    responseType: {
      type: String,
      required: false,
      default: void 0
    },
    label: {
      type: String,
      required: false,
      default: void 0
    },
    tooltip: {
      type: String,
      required: false,
      default: void 0
    },
    // Flags
    submit: {
      type: Boolean,
      required: false,
      default: void 0
    },
    targetBlank: {
      type: Boolean,
      required: false,
      default: void 0
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: void 0
    },
    noIconType: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    "ajax-action-start",
    "ajax-action-success",
    "ajax-action-failed"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    const { isTheme } = useTheming();
    const { handleUnstructuredError } = useMessages();
    const { responseAction } = useActions();
    const attrs = useAttrs();
    const props = __props;
    const emits = __emit;
    const tooltipValue = ref(false);
    const ajaxLoading = ref(false);
    const externalLoading = ref(false);
    const isLoading = computed(() => (props.ajax ? ajaxLoading.value : props.loading) || externalLoading.value);
    const getLoaderColor = () => {
      if (props.loaderColor) {
        return props.loaderColor;
      }
      if (props.disabled) {
        return "dark";
      }
      switch (props.type) {
        case ButtonType.PRIMARY:
          return isTheme(Theme.CARY) ? "white" : "button-primary";
        case ButtonType.DANGER:
          return "white";
        case ButtonType.SECONDARY:
          return "dark";
        default:
          return props.loaderColor;
      }
    };
    const iconOnly = () => {
      var _a;
      return !props.noIconType && !props.label && !((_a = attrs.portalSlots) == null ? void 0 : _a.includes("default"));
    };
    const iconSize = computed(() => {
      if ([
        ButtonType.TERTIARY,
        ButtonType.TERTIARY_NEUTRAL,
        ButtonType.TERTIARY_AGENT,
        ButtonType.TERTIARY_DANGER
      ].includes(props.type)) {
        return 16;
      }
      switch (props.size) {
        case ButtonSize.SMALL:
          return 16;
        case ButtonSize.MEDIUM:
        case ButtonSize.LARGE:
        case ButtonSize.XL:
        default:
          return 24;
      }
    });
    const getExtraAttrs = () => {
      let extraAttrs = {};
      if (props.element === ButtonElement.A) {
        extraAttrs["role"] = "button";
        if (!props.disabled) {
          extraAttrs["href"] = props.href;
        }
        if (props.targetBlank) {
          extraAttrs["target"] = "_blank";
        }
      } else if (props.submit ?? props.type === ButtonType.PRIMARY) {
        extraAttrs = {
          type: "submit"
        };
      } else {
        extraAttrs = {
          type: "button"
        };
      }
      return { ...attrs, ...extraAttrs };
    };
    const requestHeaders = () => {
      var _a, _b;
      const headers = {};
      if (!((_a = props.onSuccess) == null ? void 0 : _a.reload) && !((_b = props.onSuccess) == null ? void 0 : _b.redirect)) {
        headers["X-WITH-FLASH-MESSAGES"] = "1";
      }
      return headers;
    };
    const startLoading = () => {
      const { type } = getExtraAttrs();
      if (type === "submit") {
        externalLoading.value = true;
      }
    };
    const stopLoading = () => {
      externalLoading.value = false;
    };
    __expose({
      startLoading,
      stopLoading
    });
    const buttonAjaxCall = async () => {
      if (props.disabled || isLoading.value) {
        return false;
      }
      if (!props.ajax) {
        return true;
      }
      try {
        emits("ajax-action-start");
        ajaxLoading.value = true;
        const { data, headers } = await axios({
          url: props.url,
          data: props.ajaxParams,
          method: props.ajaxMethod,
          headers: requestHeaders(),
          responseType: props.responseType
        });
        const actionResponse = await responseAction(data, headers, props.onSuccess);
        emits("ajax-action-success", data);
        ajaxLoading.value = await actionResponse.actionPromise;
      } catch (error) {
        console.error(error);
        handleUnstructuredError(props.ajaxErrorMessagePath, error);
        emits("ajax-action-failed", error);
        ajaxLoading.value = false;
      }
    };
    const wsAnalyticsValue = computed(() => {
      return attrs["ws-analytics"] || attrs["v-ws-analytics"];
    });
    return (_ctx, _cache) => {
      const _component_portal_slot = resolveComponent("portal-slot");
      const _directive_ws_analytics = resolveDirective("ws-analytics");
      return openBlock(), createElementBlock(Fragment, null, [
        __props.tooltip ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          placement: __props.tooltipPlacement,
          "model-value": tooltipValue.value
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.tooltip), 1)
          ]),
          _: 1
        }, 8, ["placement", "model-value"])) : createCommentVNode("", true),
        withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.element), mergeProps({
          class: [
            "ws-button",
            `type-` + __props.type,
            `size-` + __props.size,
            {
              "icon-only": iconOnly(),
              "icon-right": __props.iconRight,
              "full-width": __props.fullWidth,
              "state-loading": isLoading.value
            }
          ],
          disabled: __props.disabled ? true : null
        }, getExtraAttrs(), {
          onClick: buttonAjaxCall,
          onMouseenter: _cache[0] || (_cache[0] = ($event) => tooltipValue.value = true),
          onFocusin: _cache[1] || (_cache[1] = ($event) => tooltipValue.value = true),
          onMouseleave: _cache[2] || (_cache[2] = ($event) => tooltipValue.value = false),
          onFocusout: _cache[3] || (_cache[3] = ($event) => tooltipValue.value = false)
        }), {
          default: withCtx(() => [
            isLoading.value ? (openBlock(), createBlock(WsSpinner, {
              key: 0,
              color: getLoaderColor(),
              width: unref(isTheme)(unref(Theme).ACTIVE_24) ? "50px" : void 0
            }, null, 8, ["color", "width"])) : createCommentVNode("", true),
            createBaseVNode("div", {
              class: normalizeClass(["ws-button__content", { "loading": isLoading.value }])
            }, [
              __props.icon ? (openBlock(), createBlock(WsIcon, {
                key: 0,
                name: __props.icon,
                size: iconSize.value
              }, null, 8, ["name", "size"])) : createCommentVNode("", true),
              __props.label ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(__props.label), 1)
              ], 64)) : (openBlock(), createBlock(_component_portal_slot, {
                key: 2,
                slot: _ctx.$slots.default,
                "component-id": _ctx.$attrs["component-id"],
                name: "default"
              }, null, 8, ["slot", "component-id"]))
            ], 2)
          ]),
          _: 1
        }, 16, ["class", "disabled"])), [
          [_directive_ws_analytics, wsAnalyticsValue.value]
        ])
      ], 64);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsButton.vue.es2.js.map
